import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { BarChart3, LogOut } from 'lucide-react';
import { AppBrandMark } from '@/components/brand/AppBrandMark';
import '@/styles/artis-brand.css';

export default function InvestorLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const signOut = () => {
    logout();
    navigate('/login');
  };

  const active = location.pathname.startsWith('/investor/business-reports');

  return (
    <div className="artis-theme min-h-screen bg-artis-cream font-artis-sans text-artis-brown">
      <header className="sticky top-0 z-30 border-b border-artis-brown/10 bg-artis-cream/95 backdrop-blur-md">
        <div className="mx-auto flex max-w-[1400px] items-center justify-between gap-4 px-4 py-4 sm:px-6">
          <div className="flex min-w-0 items-center gap-4">
            <AppBrandMark variant="light" className="max-w-[150px] shrink-0 sm:max-w-[170px]" />
            <div className="hidden min-w-0 border-l border-artis-brown/15 pl-4 sm:block">
              <p className="text-[10px] font-semibold uppercase tracking-[0.24em] text-artis-gold">
                Investor Portal
              </p>
              <h1 className="font-artis-serif text-lg font-semibold tracking-tight text-artis-brown-dark sm:text-xl">
                Business Reports
              </h1>
            </div>
          </div>
          <div className="flex shrink-0 items-center gap-2 sm:gap-3">
            <p className="hidden max-w-[180px] truncate text-sm text-artis-slate lg:block">{user?.name}</p>
            <button
              type="button"
              onClick={signOut}
              className="inline-flex items-center gap-2 rounded-full border border-artis-brown/20 bg-white/70 px-3 py-2 text-sm text-artis-brown transition hover:border-artis-gold/40 hover:bg-white hover:text-artis-brown-dark sm:px-4"
            >
              <LogOut className="h-4 w-4" />
              <span className="hidden sm:inline">Sign out</span>
            </button>
          </div>
        </div>
        <nav className="mx-auto flex max-w-[1400px] gap-2 px-4 pb-4 sm:px-6">
          <Link
            to="/investor/business-reports"
            className={`inline-flex shrink-0 items-center gap-2 rounded-full px-4 py-2 text-sm font-medium transition ${
              active
                ? 'bg-artis-gold text-white shadow-md shadow-artis-gold/25'
                : 'text-artis-slate hover:bg-artis-sand/60 hover:text-artis-brown-dark'
            }`}
          >
            <BarChart3 className="h-4 w-4" />
            Reports
          </Link>
        </nav>
      </header>

      <main className="relative mx-auto max-w-[1400px] px-4 pb-10 pt-2 sm:px-6 sm:pb-12">
        <div className="overflow-hidden rounded-2xl border border-artis-brown/10 bg-white text-artis-brown-dark shadow-xl shadow-artis-brown/10 ring-1 ring-artis-sand/80">
          <Outlet />
        </div>
      </main>

      <footer className="border-t border-artis-brown/10 bg-artis-brown-dark px-4 py-3 text-center">
        <p className="text-[10px] font-medium uppercase tracking-[0.28em] text-artis-sand/80">
          TRUE ARTIS · Aesthetics Redefined
        </p>
      </footer>
    </div>
  );
}
